import type { FaireProductEntity } from "../../entity_types/product";

export const p_baarzszdv2: FaireProductEntity = {
  token: "p_baarzszdv2",
  type: "product",
  name: "Silk Sleep Mask",
  brandName: "Bath Accessories Company",
  imageUrl:
    "https://cdn.faire.com/fastly/bafc26b3d826c3a2beae9ad54379cfcfb190695ac91e0791c694b64f35ef6cbb.png",
  priceDollars: 2.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0bcc7221d47f30393cdd43c8fa864b5009d7b408bd2a96eb65ad641ab19950e0.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
